module.exports = __webpack_public_path__ + "img/CanvasEcoUs.bcbdd3d6.jpg";